import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
  TextField,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import RefreshIcon from "@mui/icons-material/Refresh";
import { BASE_URL } from "../../constants";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

const PendingReports = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchAllReports = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/pathology/get-pending-reports-for-approval`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      console.log("DDDD", data);
      //   const reqData = data?.reports?.map((report) => {
      //     return {
      //       _id: report._id,
      //       date: report.sampleCollectedDate,
      //       invoiceId: report.invoice.invoiceId,
      //       patientName: report.patientId.name,
      //       patientID: report.patientId.patientID,
      //     };
      //   });
      //   setReports(reqData);
      const reqData = data?.reports?.map((path) => {
        return {
          // _id: path._id,
          // invoice: path?.invoice?.invoiceId,
          // doctorName: path?.doctorId?.name,
          // patientName: path?.patientId?.name,
          // patientID: path?.patientId?.patientID,
          // report: path?.result,
          // widalReport: path?.widalResult,
          // patientId: path?.patientId,
          // doctorId: path?.doctorId,
          // reportFileUrl: path?.reportFileUrl,
          // date: path?.sampleCollectedDate,
          // doctorSignatory: path?.doctorSignatory,
          // techSignatory: path?.techSignatory,
          // widalDoctorSignatory: path?.widalDoctorSignatory,
          // widalTechSignatory: path?.widalTechSignatory,
          _id: path._id,
          invoice: path?.invoice?.invoiceId,
          date: path?.sampleCollectedDate,
          doctorName: path?.doctorId?.name,
          patientName: path?.patientId?.name,
          report: path?.result,
          widalReport: path?.widalResult,
          sampleCollectedDate: path?.sampleCollectedDate,
          sampleCollectedTime: path?.sampleCollectedTime,
          createdAt: path?.createdAt,
          patientId: path?.patientId?.patientID,
          doctorId: path?.doctorId,
          centreId: path?.invoice?.centerId,
          reportFileUrl: path?.reportFileUrl,
          widalReportFileUrl: path?.widalReportFileUrl,
          overallNormalStatus: path?.overallNormalStatus,
          overallWidalStatus: path?.overallWidalStatus,
          signatoryDoctor: path?.doctorSignatory,
          techSignatory: path?.techSignatory,
          widalDoctorSignatory: path?.widalDoctorSignatory,
          widalTechSignatory: path?.widalTechSignatory,
        };
      });
      setReports(reqData);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllReports();
  }, []);

  const handleReload = () => {
    fetchAllReports();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
    setPage(0);
  };

  const filteredReports = reports?.filter((doctor) => {
    return Object.values(doctor).some((value) =>
      String(value).toLowerCase().includes(searchQuery),
    );
  });

  const paginatedreports = filteredReports.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const getInvestigationsWithMethods = (reports) => {
    const result = {};
    for (let i = 0; i < reports.length; i++) {
      reports[i].investigations.forEach((investigation) => {
        const methodWithResult = investigation?.methods.find(
          (method) => method.result !== "",
        );
        if (methodWithResult) {
          result[investigation._id] = methodWithResult._id;
        }
        investigation?.subInvestigations.forEach((subInvestigation) => {
          const subMethodWithResult = subInvestigation.methods.find(
            (method) => method.result !== "",
          );

          if (subMethodWithResult) {
            result[subInvestigation._id] = subMethodWithResult._id;
          }
        });
      });
    }
    return result;
  };

  const view = (pathology, tab) => {
    console.log("PATHOOOOOOOO", pathology);
    const selectedMethods = getInvestigationsWithMethods(pathology.report);
    navigate("/dashboard/lab/pathology", {
      // state: {
      //   reportId: pathology._id,
      //   report: pathology.report,
      //   sentInvoice: {
      //     patientId: pathology.patientId,
      //     doctorId: pathology.doctorId,
      //   },
      //   sentSelectedMethods: selectedMethods,
      //   doctorSignatory: pathology.doctorSignatory,
      //   techSignatory: pathology.techSignatory,
      //   reqType: "approval",
      // },
      state: {
        reportId: pathology._id,
        report: pathology.report,
        sentInvoice: {
          patientId: pathology.patientId,
          doctorId: pathology.doctorId,
        },
        sentSelectedMethods: selectedMethods,
        doctorSignatory: pathology.signatoryDoctor,
        techSignatory: pathology.techSignatory,
        reqType: "approval",
        tab: tab,
        widalReport: pathology.widalReport,
        widalDoctorSignatory: pathology.widalDoctorSignatory,
        widalTechSignatory: pathology.widalTechSignatory,
      },
    });
  };

  console.log(paginatedreports);
  return (
    <Box sx={{ mt: 5 }}>
      <TableContainer
        component={Paper}
        elevation={3}
        sx={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <Chip
            avatar={
              <Avatar sx={{ backgroundColor: "#d0f0c0", color: "#000" }}>
                {reports.length}
              </Avatar>
            }
            label="reports"
            color="success"
          />
          <TextField
            placeholder="Search reports"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearch}
            sx={{ width: "20%", ml: "auto" }}
          />
          <button
            onClick={handleReload}
            style={{
              display: "flex",
              alignItems: "center",
              border: "none",
              background: "none",
              cursor: "pointer",
              padding: "8px",
            }}
          >
            <RefreshIcon style={{ color: "#1976d2", fontSize: "24px" }} />
          </button>
        </Box>

        <Table>
          <TableHead
            sx={{
              backgroundColor: "#d9e2ff",
              "& .MuiTableCell-head": {
                fontWeight: "bold",
                fontSize: "14px",
                color: "#5c6bc0",
                textTransform: "uppercase",
              },
            }}
          >
            {/* date, invoiceid, parient name, */}
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Invoice ID</TableCell>
              <TableCell>Patient Name</TableCell>
              <TableCell>Patient ID</TableCell>
              <TableCell align="center">View</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedreports.map((report) => (
              <TableRow
                key={report._id}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f1f8ff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  },
                  transition:
                    "background-color 0.2s ease, box-shadow 0.2s ease",
                }}
              >
                <TableCell>{report.date}</TableCell>
                <TableCell>{report.invoice}</TableCell>
                <TableCell>{report.patientName}</TableCell>
                <TableCell>{report.patientId}</TableCell>
                <TableCell align="center">
                  {report?.report?.length > 0 && (
                    <Box>
                      <Tooltip title="View Normal Report" arrow placement="top">
                        <IconButton size="small">
                          <RemoveRedEyeIcon
                            color="primary"
                            sx={{ cursor: "pointer" }}
                            onClick={() => view(report, "normal")}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                  {report?.widalReport?.data?.length > 0 && (
                    <Box>
                      <Tooltip title="View Widal Report" arrow placement="top">
                        <IconButton size="small">
                          <RemoveRedEyeIcon
                            color="primary"
                            sx={{ cursor: "pointer" }}
                            onClick={() => view(report, "widal")}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={filteredReports.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </TableContainer>
    </Box>
  );
};

export default PendingReports;
